import { render, staticRenderFns } from "./type4.vue?vue&type=template&id=bae2b83e&scoped=true&"
import script from "./type4.vue?vue&type=script&lang=js&"
export * from "./type4.vue?vue&type=script&lang=js&"
import style0 from "./type4.vue?vue&type=style&index=0&id=bae2b83e&prod&scoped=true&lang=css&"
import style1 from "./type4.vue?vue&type=style&index=1&id=bae2b83e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae2b83e",
  null
  
)

export default component.exports